import { FC, lazy, Suspense } from "react";
import { Stack } from "@fluentui/react";
import { FixedList, IInputField } from "cayo.ui";
import { IColumn } from "@cayo/shared/api/types/schema";
import { withHidden } from "@cayo/shared/components/Hoc/withHidden";
import { apiMocks } from "./apiMocks";
import { useJoinToGroupsGrid } from "./hooks/useJoinToGroupsGrid";
import { IJoinToGroupsGrid } from "./types";

const ObjectSelectionDialog = lazy(
  () => import("@cayo/core/admin-components/dialogs/ObjectSelectionDialog/ObjectSelectionDialog")
);

interface JoinToGroupsGridProps extends IInputField, IJoinToGroupsGrid {}

const JoinToGroupsGrid: FC<JoinToGroupsGridProps> = (props) => {
  const { name, label, columns, dataTestId, setValue } = props;

  const { isPickerVisible, hidePicker, items, addItems, commands } = useJoinToGroupsGrid({
    columns: columns as IColumn[],
    setValue,
    readOnly: props.readOnly,
  });

  return (
    <Stack>
      {isPickerVisible && (
        <Suspense fallback={null}>
          <ObjectSelectionDialog
            searchScopes={apiMocks.searchScopes as any}
            modalOptions={apiMocks.modalOptions}
            keyProp="originalSpn"
            onClose={hidePicker}
            onSelected={(items) => {
              addItems(items);
              return Promise.resolve();
            }}
          />
        </Suspense>
      )}
      <FixedList
        name={name!}
        label={label}
        value={items}
        columns={columns}
        dataTestId={dataTestId}
        setValue={() => {}}
        layoutMode={"justified"}
        selectionMode={"multiple"}
        commands={commands}
      />
    </Stack>
  );
};

export default withHidden(JoinToGroupsGrid);
